<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="bg-white rounded box-shadow p-3">
      <div v-if="Object.keys(ses).length !== 0">
        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">EP Type</strong>
              {{ ses.ep_type.desc }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">Form Number</strong>
              {{ ses.form_no }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">Mobile Number</strong>
                {{ ses.mobile }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">
                  <span v-if="ses.id_type === 'N'">National ID</span>
                  <span v-if="ses.id_type === 'P'">Passport No.</span>
                  <span v-if="ses.id_type === 'B'">Birth Certificate No.</span>
                </strong>
                {{ ses.nid }}
              </p>
            </div>
          </div>
        </div>

        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1"
                >1.1 Household Number</strong
              >
              {{ ses.household_number }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1"
                >1.2 Name Household Head/ Institution Secretary</strong
              >
              {{ ses.name }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">
                  <span v-if="ses.father_hus_type === 'F'"
                    >1.3 Fathers Name</span
                  >
                  <span v-if="ses.father_hus_type === 'H'"
                    >1.3 Husband Name</span
                  >
                  <span v-if="ses.father_hus_type === 'S'">1.3 Spouse Name</span>
                </strong>
                {{ ses.father_husband_name }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">1.4 Mothers Name</strong>
                {{ ses.mother_name }}
              </p>
            </div>
          </div>
        </div>

        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">1.5 Date Of Birth</strong>
              {{ ses.dob }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">1.6 Gender</strong>
              {{ ses.gender.desc }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">1.7 Religion</strong>
                {{ ses.religion.desc }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">1.8 Education</strong>
                {{ ses.education.desc }}
              </p>
            </div>
          </div>
        </div>

        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">1.9 Marital Status</strong>
              {{ ses.maritial_status.desc }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1"
                >1.10 Main Occupation</strong
              >
              {{ ses.occupation.desc }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">1.11 Village</strong>
                {{ ses.village.desc }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">1.12 Union</strong>
                {{ ses.union.desc }}
              </p>
            </div>
          </div>
        </div>

        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">1.13 Mouza</strong>
              {{ ses.mouza.desc }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">1.14 Upazila</strong>
              {{ ses.upazila.desc }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">1.15 District</strong>
                {{ ses.district.desc }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">Division</strong>
                {{ ses.division.desc }}
              </p>
            </div>
          </div>
        </div>

        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1"
                >1.16 Family/Inistitution Yearly Income</strong
              >
              {{ ses.yearly_income }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1"
                >1.17 Family/Institution Yearly Expenditure</strong
              >
              {{ ses.yearly_exp }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1"
                  >1.18 If Indigenous</strong
                >
                {{ ses.indigenous }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1"
                  >1.9 Name of Institution Secretary</strong
                >
                {{ ses.inistitution_sec }}
              </p>
            </div>
          </div>
        </div>

        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">1.20 Type Of CPR</strong>
              {{ ses.cpr.desc }}
            </p>
          </div>
        </div>
      </div>

      <div v-if="Object.keys(ses_additionals).length !== 0">
        <houseHold :ses_id="this.ses_id"></houseHold>

        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1"
                  >3.1 Owner of any land?</strong
                >
                <span v-if="ses_additionals.is_land_owner === 1">Yes</span>
                <span v-if="ses_additionals.is_land_owner === 0">No</span>
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1"
                  >3.2 Any Notice/s from DC office?</strong
                >
                <span v-for="(notice, index) in ses_additionals.dc_notices">
                  {{ notice.desc }}
                  {{index + 1 !== ses_additionals.dc_notices.length ? " ," : ""}}
                </span>
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1"
                  >3.3 Any Compensation from DC Office?</strong
                >
                <span v-if="ses_additionals.is_compensation === 1">Yes</span>
                <span v-if="ses_additionals.is_compensation === 0">No</span>
              </p>
            </div>
          </div>
        </div>

        <land :ses_id="this.ses_id"></land>

        <land-household :ses_id="this.ses_id"></land-household>

        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1"
                  >4.1 Any leased Pond/Land ?
                </strong>
                <span v-if="ses_additionals.is_lease === 1">Yes</span>
                <span v-if="ses_additionals.is_lease === 0">No</span>
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1"
                  >4.2 If Yes, Please provide details
                </strong>
                <span>N/A</span>
              </p>
            </div>
          </div>
        </div>

        <structure :ses_id="this.ses_id"></structure>
        <business :ses_id="this.ses_id"></business>
        <house :ses_id="this.ses_id"></house>
        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1"
                  >07. Affected Utilities</strong
                >
                <span v-for="(utilitie, index) in ses.utilities">
                  {{ utilitie.desc }}
                  {{ index + 1 !== ses.utilities.length ? " ," : "" }}
                </span>
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">8.1 Damage Details</strong>
              <span v-for="(uses, index) in ses.losses">
                {{ uses.desc }}
                {{ index + 1 !== ses.losses.length ? " ," : "" }}
              </span>
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1"
                  >9. Use compensation money for</strong
                >
                <span v-for="(uses, index) in ses_additionals.use_compensations">
                  {{ uses.desc }}
                  {{ index + 1 !== ses_additionals.use_compensations.length ? " ," : "" }}
                </span>
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-0 mb-0 medium black strong">
              <strong class="d-block text-dark pb-1">9.1 First three plans</strong>
              {{ ses_additionals.your_plans }}
            </p>
          </div>
        </div>

      </div>

      <hr />
      <h4>Additional Info</h4>
      <div class="row pb-1">
        <div class="col-md-6 col-sm-6 col-lg-3">
          <div class="media text-muted">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1"
                >Are you Household Head?</strong
              >
              <span v-if="ses.is_household_head === 1">Yes</span>
              <span v-if="ses.is_household_head === 0">No</span>
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-lg-3">
          <div class="media text-muted">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">Is Disabled?</strong>
              <span v-if="ses.is_disable === 1">Yes</span>
              <span v-if="ses.is_disable === 0">No</span>
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-lg-3">
          <div class="media text-muted">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">Losses</strong>
              <span v-for="(loss, index) in ses.loss_field_books" :key="index"
                >{{ loss.desc }}
                {{ index + 1 !== ses.loss_field_books.length ? " ," : "" }}
              </span>
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-lg-3">
          <p class="media-body pb-2 mb-0 medium lh-150 black strong">
            <strong class="d-block text-dark pb-1">Field Book No.</strong>
            {{ ses.field_book_sl }}
          </p>
        </div>
      </div>

      <div class="row pb-1">
        <div class="col-md-6 col-sm-6 col-lg-3">
          <div class="media text-muted">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1"
                >Survey Conducted By</strong
              >
              {{ ses.worker === null ? "Not found" : ses.worker.name }}
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-lg-3">
          <p class="media-body pb-2 mb-0 medium lh-150 black strong">
            <strong class="d-block text-dark pb-1">Survey Date</strong>
            {{ ses.survey_date }}
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import houseHold from "./house-hold.vue";
import land from "./land.vue";
import landHousehold from "./land-household.vue";
import structure from "./structure.vue";
import business from "./business.vue";
import house from "./house.vue";

import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "View SES",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, houseHold, land, landHousehold, structure, business, house },
  data() {
    return {
      title: "View SES",
      items: [
        {
          text: "SES",
          href: "/"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      ses_id: "",
      ses: {},
      ses_additionals: {}
    };
  },


  mounted() {
    this.getSes();
    this.ses_id = this.$route.params.ses_id;
  },
  methods: {
    getSes() {
      let ses_id = this.$route.params.ses_id;
      http.get("api/seses/" + ses_id).then(response => {
        if (!response.data.error) {
          this.ses = response.data.ses;
          response.data.ses_additionals === "" || response.data.ses_additionals === null ? "" : (this.ses_additionals = response.data.ses_additionals);
        }
      });
    }
  },

};
</script>
